export interface Client {
    mono: string;
    color: string;
    alt: string;
}

export const clients: Client[] = [
    {
        mono: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/clients/mc-agencianacionaldetierras.svg",
        color: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/clients/agencianacionaldetierras.svg",
        alt: "Agencia Nacional de Tierras"
    },
    {
        mono: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/clients/mc-itau.svg",
        color: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/clients/itau.svg",
        alt: "Banco ITAU"
    },

    {
        mono: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/clients/mc-javeriana.svg",
        color: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/clients/javeriana.svg",
        alt: "Pontificia Universidad Javeriana"
    },
    {
        mono: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/clients/mc-licoreslarebaja.svg",
        color: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/clients/licoreslarebaja.svg",
        alt: "Licores La Rebaja"
    },
    {
        mono: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/clients/mc-artisticvision.svg",
        color: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/clients/artisticvision.svg",
        alt: "Artistic Vision"
    },
    {
        mono: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/clients/mc-omega.svg",
        color: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/clients/omega.svg",
        alt: "Omega"
    },
    {
        mono: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/clients/mc-proactive.svg",
        color: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/clients/proactive.svg",
        alt: "Proactive Smartpole"
    },
    {
        mono: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/clients/mc-daccach.svg",
        color: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/clients/daccach.svg",
        alt: "Daccach"
    }
];

